import { Moon, Sun } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/providers/theme/use-theme';

interface ThemeToggleProps {
  className?: string;
  variant?: 'pill' | 'icon';
}

export function ThemeToggle({ className, variant = 'pill' }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();

  if (variant === 'icon') {
    return (
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          toggleTheme();
        }}
        className={cn(
          'inline-flex size-9 items-center justify-center rounded-[10px] border border-border-strong text-foreground-2 transition-colors hover:bg-muted',
          className,
        )}
        aria-label="Alternar tema"
      >
        {theme === 'dark' ? (
          <Sun className="size-4" strokeWidth={1.6} />
        ) : (
          <Moon className="size-4" strokeWidth={1.6} />
        )}
      </button>
    );
  }

  return (
    <div
      className={cn(
        'flex w-16 h-8 p-1 rounded-full cursor-pointer transition-all duration-300',
        theme === 'dark'
          ? 'bg-zinc-950 border border-zinc-800'
          : 'bg-white border border-zinc-200',
        className,
      )}
      onClick={(e) => {
        e.stopPropagation();
        toggleTheme();
      }}
      role="button"
      tabIndex={0}
    >
      <div className="flex justify-between items-center w-full">
        <div
          className={cn(
            'flex justify-center items-center w-6 h-6 rounded-full transition-transform duration-300',
            theme === 'dark'
              ? 'transform translate-x-0 bg-zinc-800'
              : 'transform translate-x-8 bg-gray-200',
          )}
        >
          {theme === 'dark' ? (
            <Moon className="w-4 h-4 text-white" strokeWidth={1.5} />
          ) : (
            <Sun className="w-4 h-4 text-gray-700" strokeWidth={1.5} />
          )}
        </div>
        <div
          className={cn(
            'flex justify-center items-center w-6 h-6 rounded-full transition-transform duration-300',
            theme === 'dark' ? 'bg-transparent' : 'transform -translate-x-8',
          )}
        >
          {theme === 'dark' ? (
            <Sun className="w-4 h-4 text-gray-500" strokeWidth={1.5} />
          ) : (
            <Moon className="w-4 h-4 text-black" strokeWidth={1.5} />
          )}
        </div>
      </div>
    </div>
  );
}
